<script setup lang="ts">
import { useHead } from "@vueuse/head";

import { getMonth } from "~/modules/helpers/day";

import { monthNames } from "~/modules/constants/month_names";

const route = useRoute();

useHead({
  // Can be static or computed
  title: "РУСДРАМ",
  meta: [
    {
      hid: "title",
      property: "title",
      content: "РУСДРАМ",
    },
    {
      hid: "og:title",
      property: "og:title",
      content: "РУСДРАМ",
    },
    {
      hid: "description",
      name: "description",
      content:
        "Спектакли | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "og:description",
      property: "og:description",
      content:
        "Спектакли | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "url",
      name: "url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "og:url",
      property: "og:url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "image",
      name: "image",
      content: "https://rusdram.org/rusdram.jpg",
    },
    {
      name: "og:image",
      property: "og:image",
      content: "https://rusdram.org/rusdram.jpg",
    },
  ],
});

const { $get } = useAxios();

const now = Date.now();

const { data: posters, pending: isLoaded } = await useAsyncData(
  "get actual posters for posters page",
  () =>
    $get(
      `/api/v3/poster?_sort=date:asc&date_gt=${new Date(
        new Date(now).setHours(new Date(now).getHours() - 1)
      ).toISOString()}`
    )
);

const postersNew = computed(() => posters.value);

const selectedMonth = ref([]);
const selectedGenres = ref([]);

const months = computed(() => {
  const res = [];
  posters.value.forEach((poster) => {
    const month = getMonth(new Date(poster.date));
    if (!res.includes(month)) {
      res.push(month);
    }
  });
  return res;
});

const genres = computed(() => {
  const res = [];
  posters.value.forEach(({ perform: { genre } }) => {
    if (!res.includes(genre)) {
      res.push(genre);
    }
  });
  return res;
});

const postersToRender = computed(() => {
  let res = posters.value;
  if (selectedMonth.value.length > 0)
    res = res.filter((poster) => {
      if (selectedMonth.value.indexOf(new Date(poster.date).getMonth()) !== -1)
        return poster;
    });
  if (selectedGenres.value.length > 0) {
    res = res.filter((poster) => {
      if (selectedGenres.value.indexOf(poster.perform.genre) !== -1)
        return poster;
    });
  }
  return res;
});

function selectMonth(months) {
  selectedMonth.value = [];
  months.forEach((month) => {
    if (selectedMonth.value.indexOf(monthNames.indexOf(month)) === -1)
      selectedMonth.value.push(monthNames.indexOf(month));
    else {
      selectedMonth.value.splice(
        selectedMonth.value.indexOf(monthNames.indexOf(month)),
        1
      );
    }
  });
}

function selectGenre(genres) {
  selectedGenres.value = [];
  genres.forEach((genre) => {
    if (selectedGenres.value.indexOf(genre) === -1)
      selectedGenres.value.push(genre);
    else {
      selectedGenres.value.splice(selectedGenres.value.indexOf(genre), 1);
    }
  });
}
</script>

<template>
  <nuxt-layout name="default">
    <div v-if="!isLoaded">
      <div v-if="posters">
        <r-section v-if="posters.length">
          <div class="flex flex-row flex-nowrap gap-x-10 relative">
            <r-multy-select
              class="flex flex-col relative min-w-1/4"
              :options="months"
              @r:change="selectMonth"
              title="Месяц"
            ></r-multy-select>
            <div class="hidden xl:block w-0.5 bg-gray"></div>
            <r-multy-select
              class="hidden xl:flex flex-col relative"
              :options="genres"
              @r:change="selectGenre"
              type="flex"
              title="Жанры"
            ></r-multy-select>
          </div>
          <div
            class="grid grid-cols-1 gap-7 md:grid-cols-2 xl:grid-cols-1 mt-7"
          >
            <r-poster-card-wide
              v-for="poster in postersToRender"
              :key="poster._id"
              :poster="poster"
            />
          </div>
        </r-section>
        <Empty v-else />
      </div>
    </div>
    <r-full-page-pro-loader v-else></r-full-page-pro-loader>
  </nuxt-layout>
</template>
